<template>
  <div class="row pt-1" v-if="berechtigungen.m_geschaeftspartner.read">
    <div class="col-lg-12">
      <div class="tile-categorie-frame">
        <div class="tile-categorie">
          <div class="header">
            <span>{{ $t("global.offers") }}</span>
          </div>
          <div class="body">
            <div class="row">
              <!-- Start Angebote -->
              <div :class="kachelCol">
                <div class="tile-frame h-1" :class="kachelStyle">
                  <router-link to="/angebote">
                    <div class="tile bg-turkis inverted">
                      <div class="icon-container fa-container">
                        <font-awesome-icon icon="fa-duotone fa-wheat" />
                      </div>
                      <div class="title">
                        <div>{{ $t("global.offers") }}</div>
                      </div>
                    </div>
                  </router-link>
                </div>
              </div>
              <!-- Ende Angebote -->

              <div class="row">
                <!-- Start Einsatzliste -->
                <div :class="kachelKleinCol">
                  <div class="tile-frame h-1" :class="kachelKleinStyle">
                    <router-link :to="{ name: 'Einsatzliste' }">
                      <div class="tile bg-light-mint inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon
                            icon="fa-duotone fa-wheat"
                            transform="left-1 shrink-4"
                          />
                        </div>
                        <div class="title">
                          {{ $t('global.deployments') }}
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Einsatzliste -->

                <!-- Start Verfügbarkeiten -->
                <div :class="kachelKleinCol">
                  <div class="tile-frame h-1" :class="kachelKleinStyle">
                    <router-link :to="{ name: 'Einsatzliste' }">
                      <div class="tile bg-light-mint inverted">
                        <div class="icon-container fa-container">
                          <font-awesome-icon
                            icon="fa-duotone fa-wheat"
                            transform="left-1 shrink-4"
                          />
                        </div>
                        <div class="title">
                          {{ $t('global.deployments') }}
                        </div>
                      </div>
                    </router-link>
                  </div>
                </div>
                <!-- Ende Verfügbarkeiten -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "StartseiteAngebote",
  props: {
    kachelStyle: {
      type: String,
      default: "centered",
    },
    kachelCol: {
      type: String,
      default: "col-xl-6 col-lg-6 col-md-12",
    },
    kachelKleinStyle: {
      type: String,
      default: "centered",
    },
    kachelKleinCol: {
      type: String,
      default: "col-xl-3 col-lg-6 col-md-12",
    },
  },
};
</script>
